import { createContext } from 'react'

const LocaleContext = createContext({
    language: 'en',
    locale: 'en-us',
    isImplicit: false // '/' is implicitly en-us
})

export default LocaleContext
